import { VARIANCE_ACTIONS } from './varianceActions.js';

const normalized = (value) => String(value || '').trim().toLowerCase();

export const forceEvidenceKey = (action = {}) => [
  action.actionType,
  action.source || action.sourceFile,
  action.targetSource || action.targetFile,
  action.sourceRowKey || '',
  action.targetRowKey || '',
  action.manualOrderItemId || '',
  action.manualReferenceId || '',
].map(normalized).join('|');

export const contextWithForcedEvidence = (varianceContext = {}) => {
  const previewAction = varianceContext?.draftPreview?.action;
  const action = varianceContext?.draftPreview?.evidenceAction || previewAction;
  const destructiveFileAction = previewAction && (
    previewAction.actionType === VARIANCE_ACTIONS.REMOVE_FROM_CPQ
    || previewAction.actionType === VARIANCE_ACTIONS.REMOVE_FROM_GM
    || previewAction.compiledMutation === 'remove'
  );
  const hasEvidenceBinding = Boolean(
    action
    && !destructiveFileAction
    && (
      action.actionType === VARIANCE_ACTIONS.FORCE_EVIDENCE_MATCH
      || action.manualOrderItemId
      || action.manualReferenceId
      || action.bindingMethod
      || action.salesforceAccountId
    )
  );
  if (!hasEvidenceBinding) return varianceContext;
  const isCpqContext = varianceContext.source === 'cpq';
  const inheritedCode = action.replacementProductCode || action.sourceProductCode || varianceContext.productCode;
  const inheritedPrice = action.proposedPrice ?? varianceContext.price;
  return {
    ...varianceContext,
    productCode: inheritedCode,
    price: inheritedPrice,
    originalFilePrice: varianceContext.originalFilePrice ?? varianceContext.price,
    orderItemId: isCpqContext ? varianceContext.orderItemId : action.manualOrderItemId || varianceContext.orderItemId,
    sourceOrderItemId: isCpqContext
      ? varianceContext.sourceOrderItemId || varianceContext.orderItemId
      : varianceContext.sourceOrderItemId,
    matchedAppSheetOrderItemId: isCpqContext
      ? action.manualOrderItemId || varianceContext.matchedAppSheetOrderItemId
      : varianceContext.matchedAppSheetOrderItemId,
    referenceId: action.manualReferenceId || varianceContext.referenceId,
    salesforceAccountId: action.salesforceAccountId || varianceContext.salesforceAccountId,
    salesforceAccountName: action.salesforceAccountName || varianceContext.salesforceAccountName,
    bindingMethod: action.bindingMethod || varianceContext.bindingMethod,
    bindingConfidence: action.bindingConfidence || varianceContext.bindingConfidence,
    row: {
      ...(varianceContext.row || {}),
      productCode: inheritedCode,
      orderItemId: isCpqContext ? varianceContext.row?.orderItemId : action.manualOrderItemId || varianceContext.row?.orderItemId,
      __orderItemId: isCpqContext ? varianceContext.row?.__orderItemId : action.manualOrderItemId || varianceContext.row?.__orderItemId,
      matchedAppSheetOrderItemId: isCpqContext
        ? action.manualOrderItemId || varianceContext.row?.matchedAppSheetOrderItemId
        : varianceContext.row?.matchedAppSheetOrderItemId,
      referenceId: action.manualReferenceId || varianceContext.row?.referenceId,
      salesforceAccountId: action.salesforceAccountId || varianceContext.row?.salesforceAccountId,
      salesforceAccountName: action.salesforceAccountName || varianceContext.row?.salesforceAccountName,
      accountMatch: {
        ...(varianceContext.row?.accountMatch || {}),
        orderItemId: action.manualOrderItemId || varianceContext.row?.accountMatch?.orderItemId,
        referenceId: action.manualReferenceId || varianceContext.row?.accountMatch?.referenceId,
        salesforceAccountId: action.salesforceAccountId || varianceContext.row?.accountMatch?.salesforceAccountId,
        salesforceAccountName: action.salesforceAccountName || varianceContext.row?.accountMatch?.salesforceAccountName,
        matchMethod: action.bindingMethod || varianceContext.row?.accountMatch?.matchMethod,
        confidence: action.bindingConfidence || varianceContext.row?.accountMatch?.confidence,
      },
    },
  };
};
